import { useEffect, useRef } from 'react';

export default function useTouchEvents({
  onTap,
  onDoubleTap,
  onLongTap,
  tapThreshold = 300,
  doubleTapThreshold = 300,
  longTapThreshold = 1200,
}) {
  const touchTimeoutRef = useRef(null);
  const lastTapRef = useRef(0);

  const handleTouchStart = () => {
    touchTimeoutRef.current = setTimeout(() => {
      onLongTap && onLongTap();
    }, longTapThreshold);
  };

  const handleTouchEnd = () => {
    clearTimeout(touchTimeoutRef.current);
  };

  const handleTouchTap = () => {
    const now = Date.now();
    if (now - lastTapRef.current < doubleTapThreshold) {
      onDoubleTap && onDoubleTap();
    } else {
      lastTapRef.current = now;
      touchTimeoutRef.current = setTimeout(() => {
        onTap && onTap();
      }, tapThreshold);
    }
  };

  useEffect(() => {
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    document.addEventListener('touchcancel', handleTouchEnd);
    document.addEventListener('touchend', handleTouchTap);

    return () => {
      clearTimeout(touchTimeoutRef.current);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
      document.removeEventListener('touchcancel', handleTouchEnd);
      document.removeEventListener('touchend', handleTouchTap);
    };
  }, [onTap, onDoubleTap, onLongTap, tapThreshold, doubleTapThreshold, longTapThreshold]);

  return {};
}
